"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBootcampSentenceWithFlashcardsCount = exports.BootcampSentenceWithFlashcardsCountSchema = exports.isBootcampSentence = exports.BootcampSentenceSchema = exports.isBasicBootcampSentence = exports.BasicBootcampSentenceSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const common_sentence_types_1 = require("./common_sentence_types");
const sentence_word_types_1 = require("./sentence_word_types");
const BootcampSentenceWordImageSchema = zod_1.z.object({
    height: zod_1.z.number().optional(),
    url: zod_1.z.string(),
    width: zod_1.z.number().optional(),
});
const BootcampSentenceWordSchema = zod_1.z.object({
    abstract: zod_1.z.boolean(),
    child_index: zod_1.z.number(),
    id: zod_1.z.string(),
    known_txt: zod_1.z.string(),
    known_word_id: zod_1.z.string(),
    learn_txt: zod_1.z.string(),
    learn_word_id: zod_1.z.string(),
    post_learn_txt: zod_1.z.string(),
    pre_learn_txt: zod_1.z.string(),
    root_txt: zod_1.z.string(),
    root_word_id: zod_1.z.string(),
    sentence_order: zod_1.z.number(),
    tags: sentence_word_types_1.TagSchema.array(),
    vulgar: zod_1.z.boolean(),
});
exports.BasicBootcampSentenceSchema = common_sentence_types_1.BasicSentenceSchema.extend({
    created_at: zod_1.z.string(),
    flashcards: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string(),
    }))
        .optional(),
    is_special_word_sentence: zod_1.z.literal(false),
    is_ugc: zod_1.z.literal(true),
    known_word_txt: zod_1.z.string(),
    learn_word_txt: zod_1.z.string(),
    sentence_type: zod_1.z.union([zod_1.z.literal("user_generated"), zod_1.z.literal("bootcamp")]),
});
exports.isBasicBootcampSentence = type_validation_helpers_1.getTypeValidationFunction(exports.BasicBootcampSentenceSchema);
exports.BootcampSentenceSchema = exports.BasicBootcampSentenceSchema.extend({
    sentence_words: BootcampSentenceWordSchema.array(),
});
exports.isBootcampSentence = type_validation_helpers_1.getTypeValidationFunction(exports.BootcampSentenceSchema);
exports.BootcampSentenceWithFlashcardsCountSchema = exports.BootcampSentenceSchema.extend({
    flashcardsCount: zod_1.z.number(),
});
exports.isBootcampSentenceWithFlashcardsCount = type_validation_helpers_1.getTypeValidationFunction(exports.BootcampSentenceWithFlashcardsCountSchema);
//# sourceMappingURL=bootcamp_sentence_types.js.map